import { render, staticRenderFns } from "./DashboardPurchase.vue?vue&type=template&id=59b95570&"
import script from "./DashboardPurchase.vue?vue&type=script&lang=js&"
export * from "./DashboardPurchase.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports